import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { ScrollLink } from 'site-modules/shared/components/scroll-link/scroll-link';
import { VehicleEntities } from 'client/data/models/vehicle-v2';
import { INCENTIVES_PANEL_NAME } from 'site-modules/incentives/components/incentives-panel/incentives-panel';

export class StylesIncentivesLink extends Component {
  static propTypes = {
    incentiveType: PropTypes.string.isRequired,
    onClick: PropTypes.func.isRequired,
    style: VehicleEntities.Style,
  };

  static defaultProps = {
    style: {},
  };

  /**
   * Handles click on incentive.
   */
  handleClick = () => {
    const { onClick, incentiveType, style } = this.props;
    onClick(style, incentiveType);
  };

  render() {
    return (
      <ScrollLink
        to={INCENTIVES_PANEL_NAME}
        onClick={this.handleClick}
        className="styles-incentives-link"
        scrollConfig={{
          duration: 200,
          isDynamic: true,
          smooth: true,
        }}
        tabIndex={0}
      >
        See if available
      </ScrollLink>
    );
  }
}
